module.exports = __webpack_public_path__ + "static/media/life-time.6868140a.svg";